import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseRentalAdaptationTemplates = [
  {
    id: '-223001',
    language: Language.EN,
    subject: 'Rental adaptation',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_RENTAL_ADAPTATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant</p>
          <p>The rental price will be adapted from {{formatDate leasePriceHistory.applicationDate}} going from {{getTotalPreviousPriceForFrequency lease leasePriceHistory}} € to {{getTotalFuturePriceForFrequency lease leasePriceHistory}} €.</p>
          <p>Thank you for adjusting your direct debit.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-223002',
    language: Language.FR,
    subject: 'Adaptation du loyer',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_RENTAL_ADAPTATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Le loyer sera ajusté à partir du {{formatDate leasePriceHistory.applicationDate}}, passant de {{getTotalPreviousPriceForFrequency lease leasePriceHistory}} € à {{getTotalFuturePriceForFrequency lease leasePriceHistory}} €.</p>
          <p>Merci d'ajuster votre prélèvement automatique.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-223003',
    language: Language.NL,
    subject: 'Huurprijsaanpassingen',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_RENTAL_ADAPTATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>De huur wordt aangepast vanaf {{formatDate leasePriceHistory.applicationDate}}, van {{getTotalPreviousPriceForFrequency lease leasePriceHistory}}€ naar {{getTotalFuturePriceForFrequency lease leasePriceHistory}}€.</p>
          <p>Dank u voor het aanpassen van uw automatische incasso.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-223004',
    language: Language.DE,
    subject: 'Mietpreisanpassung',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_RENTAL_ADAPTATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Der Mietpreis wird ab {{formatDate leasePriceHistory.applicationDate}} angepasst von {{getTotalPreviousPriceForFrequency lease leasePriceHistory}} € auf {{getTotalFuturePriceForFrequency lease leasePriceHistory}} €.</p>
          <p>Bitte passen Sie Ihren Dauerauftrag an.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
